import type { PortableTextTypeComponent } from '@portabletext/react';

import type { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

import VideoBlockComponent, { type VideoBlockProps } from './VideoBlock';

export interface VideoBlockPortableText extends VideoBlockProps {
  _type: 'VideoBlockPortableText';
  subtitleLanguageCode: VimeoSubtitleLanguageCodes;
}

const VideoBlockPortableText: PortableTextTypeComponent<VideoBlockPortableText> = ({ value }) => {
  return <VideoBlockComponent {...value} />;
};

export default VideoBlockPortableText;
